export default __webpack_public_path__ + "static/media/get_link.e637f32c.svg";